import React, { useCallback } from 'react';
import { StyleSheet, Image, View, Text, TouchableWithoutFeedback } from 'react-native';
import { lrpx } from "../common/utils";
import selectedImg from "../assets/images/selected.png";
import unSelectedImg from "../assets/images/un-selected.png";
const Styles = StyleSheet.create({
  disable: {
    opacity: 0.4
  },
  providerItem: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    height: lrpx(48)
  },
  itemCheckbox: {
    marginRight: lrpx(14)
  },
  itemCheckboxImage: {
    width: lrpx(16),
    height: lrpx(16)
  },
  itemContent: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    flex: 1
  },
  payMethodIcon: {
    width: lrpx(28),
    height: lrpx(28),
    marginRight: lrpx(8)
  },
  providerDesc: {
    marginLeft: lrpx(30),
    marginTop: lrpx(-5),
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    fontWeight: '400',
    fontSize: lrpx(14),
    lineHeight: lrpx(16),
    color: '#999'
  },
  providerName: {
    fontStyle: 'normal',
    fontWeight: '400',
    display: 'flex',
    alignItems: 'center',
    fontSize: lrpx(14),
    lineHeight: lrpx(21),
    color: '#000000',
    flex: 1
  },
  providerNameDesc: {
    marginLeft: lrpx(30),
    marginTop: lrpx(-5),
    marginBottom: lrpx(10),
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    fontWeight: '400',
    fontSize: lrpx(14),
    lineHeight: lrpx(16),
    color: '#999'
  }
});
const ProviderItem = props => {
  const {
    itemData,
    renderIndex,
    isSelected,
    onSelected,
    callback
  } = props;
  const onPressHandler = useCallback(() => {
    if (itemData.state === 'GRAY') {
      callback && callback('onClickPaymentMethod', {
        paymentMethod: itemData.payment_method,
        state: itemData.state
      });
    } else {
      onSelected && onSelected(itemData, renderIndex);
    }
  }, [onSelected, renderIndex, itemData]);
  return /*#__PURE__*/React.createElement(TouchableWithoutFeedback, {
    onPress: onPressHandler
  }, /*#__PURE__*/React.createElement(View, {
    style: itemData.state === 'GRAY' && Styles.disable
  }, /*#__PURE__*/React.createElement(View, {
    style: Styles.providerItem
  }, /*#__PURE__*/React.createElement(View, {
    style: Styles.itemCheckbox
  }, /*#__PURE__*/React.createElement(Image, {
    resizeMode: "contain",
    style: Styles.itemCheckboxImage,
    source: isSelected ? selectedImg : unSelectedImg
  })), /*#__PURE__*/React.createElement(View, {
    style: Styles.itemContent
  }, /*#__PURE__*/React.createElement(Image, {
    resizeMode: "contain",
    style: Styles.payMethodIcon,
    source: {
      uri: itemData.icon
    }
  }), /*#__PURE__*/React.createElement(Text, {
    style: Styles.providerName
  }, itemData.display_name))), itemData.installment_display && /*#__PURE__*/React.createElement(Text, {
    style: Styles.providerNameDesc
  }, itemData.installment_display), itemData.payment_method_desc && isSelected && /*#__PURE__*/React.createElement(Text, {
    style: Styles.providerDesc
  }, itemData.payment_method_desc)));
};
export default ProviderItem;